// nodeAccessScope.js — client mirror of functions/utils/nodeAccessScope.js (G11 / P9)

export const ACCESS_SCOPE = Object.freeze({
  OWNER_PRIVATE: 'owner_private',
  BASE: 'base',
});

function cleanString(value) {
  return String(value || '').trim();
}

export function normalizeAccessScope(value) {
  const raw = cleanString(value).toLowerCase();
  if (raw === ACCESS_SCOPE.OWNER_PRIVATE) return ACCESS_SCOPE.OWNER_PRIVATE;
  if (raw === ACCESS_SCOPE.BASE) return ACCESS_SCOPE.BASE;
  return null;
}

export function isOwnerPrivateNode(node = {}) {
  return normalizeAccessScope(node?.accessScope) === ACCESS_SCOPE.OWNER_PRIVATE;
}

/**
 * @param {object} node
 * @param {{ uid?: string|null }} viewer
 * @returns {boolean}
 */
export function canViewerAccessNode(node, viewer = {}) {
  if (!node || typeof node !== 'object') return false;
  if (!isOwnerPrivateNode(node)) return true;
  const uid = cleanString(viewer.uid);
  const owner = cleanString(node.ownerUserKey);
  return Boolean(uid && owner && uid === owner);
}

export function filterNodesForViewer(nodes = [], viewer = {}) {
  return (Array.isArray(nodes) ? nodes : []).filter((node) => (
    canViewerAccessNode(node, viewer)
  ));
}

/** Types that may be owner_private. */
export const OWNER_PRIVATE_CAPABLE_TYPES = Object.freeze([
  'PHOTO',
  'DOCUMENT',
  'FILE',
  'VIDEO',
]);

export function typeMayBeOwnerPrivate(typeKey) {
  return OWNER_PRIVATE_CAPABLE_TYPES.includes(
    cleanString(typeKey).toUpperCase(),
  );
}

/**
 * Stamps base-visible accessScope when missing.
 * Collection list queries require accessScope == "base" (or ownerUserKey);
 * missing scope is invisible to those queries even though rules treat it as base.
 *
 * @param {object} payload
 * @returns {object}
 */
export function withDefaultAccessScope(payload = {}) {
  const next = payload && typeof payload === 'object' ? { ...payload } : {};
  const existing = normalizeAccessScope(next.accessScope);
  if (existing) {
    next.accessScope = existing;
    return next;
  }
  next.accessScope = ACCESS_SCOPE.BASE;
  return next;
}

